/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getDiagLabs } from 'app/entities/diag-lab/diag-lab.reducer';
import { createEntity, getEntity, reset, updateEntity } from './diag-lab-inventory-type.reducer';

export const DiagLabInventoryTypeUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const diagLabs = useAppSelector(state => state.diagLab.entities);
  const diagLabInventoryTypeEntity = useAppSelector(state => state.diagLabInventoryType.entity);
  const loading = useAppSelector(state => state.diagLabInventoryType.loading);
  const updating = useAppSelector(state => state.diagLabInventoryType.updating);
  const updateSuccess = useAppSelector(state => state.diagLabInventoryType.updateSuccess);

  const handleClose = () => {
    navigate(`/diag-lab-inventory-type${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getDiagLabs({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastUpdated !== undefined && typeof values.lastUpdated !== 'number') {
      values.lastUpdated = Number(values.lastUpdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampEntry !== undefined && typeof values.timestampEntry !== 'number') {
      values.timestampEntry = Number(values.timestampEntry);
    }

    const entity = {
      ...diagLabInventoryTypeEntity,
      ...values,
      diagLab: diagLabs.find(it => it.id.toString() === values.diagLab?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...diagLabInventoryTypeEntity,
          diagLab: diagLabInventoryTypeEntity?.diagLab?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.diagLabInventoryType.home.createOrEditLabel" data-cy="DiagLabInventoryTypeCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.diagLabInventoryType.home.createOrEditLabel">
              Create or edit a DiagLabInventoryType
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="diag-lab-inventory-type-id"
                  label={translate('tinyMedicRestApp.diagLabInventoryType.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.diagLabInventoryType.name')}
                id="diag-lab-inventory-type-name"
                name="name"
                data-cy="name"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.diagLabInventoryType.description')}
                id="diag-lab-inventory-type-description"
                name="description"
                data-cy="description"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.diagLabInventoryType.displayKey')}
                id="diag-lab-inventory-type-displayKey"
                name="displayKey"
                data-cy="displayKey"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.diagLabInventoryType.active')}
                id="diag-lab-inventory-type-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.diagLabInventoryType.cursor')}
                id="diag-lab-inventory-type-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.diagLabInventoryType.lastUpdated')}
                id="diag-lab-inventory-type-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.diagLabInventoryType.microSec')}
                id="diag-lab-inventory-type-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.diagLabInventoryType.timestampEntry')}
                id="diag-lab-inventory-type-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                id="diag-lab-inventory-type-diagLab"
                name="diagLab"
                data-cy="diagLab"
                label={translate('tinyMedicRestApp.diagLabInventoryType.diagLab')}
                type="select"
              >
                <option value="" key="0" />
                {diagLabs
                  ? diagLabs.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/diag-lab-inventory-type" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default DiagLabInventoryTypeUpdate;
